import React, {useState} from "react";
import Div from "../lib/Div";
import MainStyle from "../../MainStyle";
import P from "../lib/P";
import {TextInput} from "react-native-paper";
import {FormikProps} from "formik";
import {getFieldError} from "../utils";
import Btn from "./Btn";
import CardDetailsModal from "../modals/CardDetailsModal";
import SavedCards from "./SavedCards";
import AllPromosModal from "../modals/AllPromosModal";
import AddNewPromoCode from "../screens/User/promos/components/AddNewPromoCode";
import FontAwesome5 from '@expo/vector-icons/FontAwesome5';

type Props = {
  formik: FormikProps<{ amount: string }>, canAddCard: boolean, amountCents: number | null, onInvalidAmount: () => void
};

const FullSwingDeposit = ({formik, canAddCard, amountCents, onInvalidAmount}: Props) => {
  const amountError = getFieldError('amount', formik);
  const [cardDepositAmountCents, setCardDepositAmountCents] = useState<number | null>(null);
  const [showAllPromos, setShowAllPromos] = useState(false);
  const [isOpenAddNewPromo, setIsOpenAddNewPromo] = useState(false);

  const openCardDetails = () => {
    if (!canAddCard) return;

    if (amountCents === null) {
      onInvalidAmount();
      return;
    }

    setCardDepositAmountCents(amountCents);
  };

  return (
    <Div w="100%" flex={1} px={16}>
      <P ta="center" fontFamily="DavisSans-Regular" mb={30}>
        Enter amount you would like to add to your account and choose a payment method
      </P>

      <TextInput
        label="Amount to deposit" onBlur={formik.handleBlur('amount')} style={[MainStyle.b_r_4, MainStyle.m_b_30]}
        value={formik.values.amount} error={!!amountError} keyboardType="numeric"
        onChangeText={text => formik.setFieldValue('amount', text)} underlineColor="transparent"
        // String icon names resolve through react-native-vector-icons, which this
        // app does not bundle (renders a placeholder box); use an explicit glyph.
        left={<TextInput.Icon icon={() => <FontAwesome5 name="dollar-sign" size={18} color="white"/>}/>}
      />

      <SavedCards amountCents={amountCents} onInvalidAmount={onInvalidAmount}/>

      <Div flex={1}/>

      {canAddCard ? (
        <Btn mt={16} mb={20} bg={amountError ? '#BBBCBF' : '#3369FF'} rounded={4} disabled={!!amountError}
             onPress={openCardDetails}>
          <P lh={56} ta="center" fontFamily="DavisSans-Medium" color={amountError ? '#494A4C' : 'white'}>
            Deposit Money
          </P>
        </Btn>
      ) : (
        <P ta="center" fontFamily="DavisSans-Regular" color="#BBBCBF" mt={16} mb={20}>
          New debit cards can only be added in the Evenplay web app. Saved cards remain available here.
        </P>
      )}

      <Btn mb={2} bg="#3369FF" rounded={4} onPress={() => setIsOpenAddNewPromo(true)}>
        <P lh={56} ta="center" fontFamily="DavisSans-Medium" color="white">Add Promo Code</P>
      </Btn>

      <Btn mb={18} onPress={() => setShowAllPromos(true)}>
        <P lh={56} ta="center" fontFamily="DavisSans-Regular" color="white" textDecorationLine="underline">
          See All Promos
        </P>
      </Btn>

      {cardDepositAmountCents !== null && (
        <CardDetailsModal
          visible amountCents={cardDepositAmountCents} onRequestClose={() => setCardDepositAmountCents(null)}
        />
      )}

      <AllPromosModal visible={showAllPromos} onClose={() => setShowAllPromos(false)}/>
      <AddNewPromoCode isOpen={isOpenAddNewPromo} onClose={() => setIsOpenAddNewPromo(false)}/>
    </Div>
  );
};

export default FullSwingDeposit;
